/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FormPage = lazyLoad(
  () => import('./index'),
  module => module.FormPage
);
